// Load polyfill is smooth scroll not is supported (safari desktop / ie 11)
(async () => {
  if(!window.CSS.supports('scroll-behavior', 'smooth')) {
    await import('smoothscroll-polyfill');
  }
})();

if (!customElements.get('slider-component')) {

  class SliderComponent extends HTMLElement {
    constructor() {
      super();

      /*
       * Check if algolia is done rendering the virtual DOM
       * Needed because algolia works with preact and sometimes the children nodes are not loaded yet
       */
      if (!this.classList.contains('algolia-recommend')) {
        const interval = setInterval(() => {
          if (this.querySelector('[data-scroller-wrapper]')) {
            clearInterval(interval);
            this.init();
          }
        }, 100);
      } else {
        this.init();
      }
    }

    init() {

      // Options
      this.options = {
        moveMultipleSlides: true,
        offset: 0,
        mobileOffset: 0,
        gradient: false,
      }

      // Get options from element data and combine with this.options
      if (this?.dataset?.options) {
        const dataOptions = parseJson(this.dataset.options);
        this.options = {
          ...this.options,
          ...dataOptions
        };
      }

      // Selectors
      this.selectors = {
        wrapper: this.querySelector('[data-scroller-wrapper]'),
        content: this.querySelector('[data-scroller-content]'),
        center: this.querySelector('[data-scroller-center]'),
        slides: this.querySelectorAll('[data-slider-slide]'),
        prevButton: this.querySelector('[data-slider-prev]'),
        nextButton: this.querySelector('[data-slider-next]')
      }

      if (!this.selectors.content) {
        this.selectors.content = this.querySelector('.slider-scroller-content');
      }

      // Drag slides with mouse
      this.dragSlider();

      // Watch slides
      this.watchSlides();

      // Resize
      this.onResize();
      window.addEventListener('resize', () => {
        this.onResize();
      });

      // Create event handlers
      this.prevButtonHandler = (event) => {
        if (!this.shouldAllowClicks()) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        this.goToNextPrevSlide('backward');
      };

      this.nextButtonHandler = (event) => {
        if (!this.shouldAllowClicks()) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        this.goToNextPrevSlide('forward');
      };

      // Prev / Next events
      if (this.selectors.prevButton) {
        this.selectors.prevButton.addEventListener('click', this.prevButtonHandler);
      }

      if (this.selectors.nextButton) {
        this.selectors.nextButton.addEventListener('click', this.nextButtonHandler);
      }

      // Add global click handler to prevent filter application during drag
      this.globalClickHandler = (event) => {
        // Check if the click is on a filter element within this slider
        if (this.contains(event.target)) {
          // Don't block navigation buttons
          if (event.target.closest('[data-slider-prev], [data-slider-next]')) {
            return;
          }

          // Check if clicks should be allowed
          if (!this.shouldAllowClicks()) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            return false;
          }
        }
      };

      // Add the global click handler with capture to intercept before other handlers
      document.addEventListener('click', this.globalClickHandler, true);

    }

    /**
     * Center insufficient slides
     */
    centerSlides() {

      if (this.dataset.options && this.dataset.options.includes('centeredSlides')) {

        // Total width of all slides
        let totalWidth = 0;
        [...this.selectors.slides].forEach((slide) => {
          if (window.innerWidth < 768) {
          totalWidth += slide.clientWidth + 12;
          } else {
            totalWidth += slide.clientWidth + 16;
          }
        });

        if (window.innerWidth < 768) {
        totalWidth = totalWidth - 12;
        } else {
          totalWidth = totalWidth - 16;
        }

        let wrapperWidth = this.selectors.center.clientWidth;

        // Center slides
        if (totalWidth < wrapperWidth) {
          this.selectors.content.classList.add('slider__content--centered');
        } else {
          this.selectors.content.classList.remove('slider__content--centered');
        }
      }
    }

    /**
     * On resize center last slide
     */
    onResize() {
      if (!this.selectors.slides[0]) {
        return;
      }

      let scroller = {
        pos: this.selectors.wrapper.scrollLeft,
        width: this.selectors.wrapper.clientWidth,
        offset: this.selectors.center ? this.selectors.center.offsetLeft : this.selectors.content.offsetLeft
      };

      let offset = scroller.offset + (window.innerWidth < 768 ? (this.options?.mobileOffset || 0) : (this.options?.offset || 0));
      if (this.selectors.content.classList.contains('slider__content--full')) {
        this.selectors.slides[this.selectors.slides.length - 1].style.paddingRight = `${offset}px`
      }

      this.centerSlides();
    }



    /**
     * Drag slides with mouse
     */
    dragSlider() {
      let options = {
        speed: 1,
        momentum: 0.9,
        velocity: 3,
        threshold: 10
      }

      let state = {
        isDown: false,
        velocity: 0,
        momentumID: null,
        isDragging: false,
        wasDragging: false,
        dragStartTime: 0,
        dragEndTime: 0
      }

      let pos = {
        start: 0,
        left: 0,
        x: 0,
      };

      const mouseMoveHandler = (event) => {
        if (!state.isDown) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        // Get current scroll positions
        const x = event.clientX - pos.left;
        const walk = (x - pos.start) * options.speed;
        const prevScrollLeft = this.selectors.wrapper.scrollLeft;

        // Update scroll position
        this.selectors.wrapper.scrollLeft = pos.left - walk;

        // Update velocity for momentum scroll
        state.velocity = (this.selectors.wrapper.scrollLeft - prevScrollLeft) * options.velocity;

        // Mark as dragging if movement exceeds threshold
        if (Math.abs(walk) >= options.threshold) {
          state.isDragging = true;

          // Disable click on slide when dragging
          [...this.selectors.slides].forEach(el => {
            el.style.pointerEvents = 'none';
          });

          // Disable click on all interactive elements
          this.querySelectorAll('a, button, input, label').forEach((el) => {
            el.addEventListener('click', clickHandler);
          });
        }

      };

      const clickHandler = (event) => {
        event.preventDefault();
        event.stopPropagation();
      }

      // Store reference to state for external access
      this.dragState = state;

      const mouseUpHandler = (event) => {
        event.preventDefault();
        event.stopPropagation();

        // Set state pointer is down to false.
        state.isDown = false;

        // Update pointer and user select
        this.selectors.wrapper.style.cursor = 'grab';
        this.selectors.wrapper.style.removeProperty('user-select');

        // Remove mouse move up event listeners
        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
        document.removeEventListener('click', mouseUpHandler);
        document.removeEventListener('mouseleave', mouseUpHandler);

        // Set drag end time and wasDragging flag
        state.dragEndTime = Date.now();
        if (state.isDragging) {
          state.wasDragging = true;
        }

        // If we were dragging, delay re-enabling clicks to prevent accidental filter application
        if (state.isDragging) {
          // Keep click blockers active for a short time after drag ends
          setTimeout(() => {
            // Re-enable pointer events on slides
            [...this.selectors.slides].forEach(el => {
              el.style.removeProperty('pointer-events');
            });

            // Remove click blockers
            this.querySelectorAll('a, button, input, label').forEach((el) => {
              el.removeEventListener('click', clickHandler);
            });

            // Reset dragging state
            state.isDragging = false;
            state.wasDragging = false;
          }, 150); // 150ms delay to prevent accidental clicks
        } else {
          // If we weren't dragging, immediately re-enable everything
          [...this.selectors.slides].forEach(el => {
            el.style.removeProperty('pointer-events');
          });

          this.querySelectorAll('a, button, input, label').forEach((el) => {
            el.removeEventListener('click', clickHandler);
          });
        }

        // State momentum animation
        beginMomentumTracking();
      };

      const mouseDownHandler = (event) => {
        // Don't start drag if select is open (for quickshop)
        if (event.target.tagName == 'SELECT') {
          return;
        }

        // Prevent default
        event.preventDefault();
        event.stopPropagation();

        // Stop current momentum loop
        cancelMomentumTracking();

        // Set state pointer is down to true.
        state.isDown = true;
        state.isDragging = false;
        state.wasDragging = false;
        state.dragStartTime = Date.now();

        // Update pointer and user select
        this.selectors.wrapper.style.cursor = 'grabbing';
        this.selectors.wrapper.style.userSelect = 'none';

        // Update positions state
        pos = {
          start: event.clientX - this.selectors.wrapper.scrollLeft,
          left: this.selectors.wrapper.scrollLeft,
          x: event.clientX
        };

        // Create mouse move up event listeners.
        document.addEventListener('mousemove', mouseMoveHandler);
        document.addEventListener('mouseup', mouseUpHandler);
        document.addEventListener('click', mouseUpHandler);
        document.addEventListener('mouseleave', mouseUpHandler);

      };

      // Momentum: Start tracking
      const beginMomentumTracking = () => {
        cancelMomentumTracking();
        state.momentumID = requestAnimationFrame(momentumLoop);
      }

      // Momentum: Cancel tracking
      const cancelMomentumTracking = () => {
        cancelAnimationFrame(state.momentumID);
      }

      // Momentum: Loop
      const momentumLoop = () => {
        this.selectors.wrapper.scrollLeft += state.velocity;
        state.velocity *= options.momentum;
        if (Math.abs(state.velocity) > 0.5) {
          state.momentumID = requestAnimationFrame(momentumLoop);
        }
      }

      // Start the script
      this.selectors.wrapper.addEventListener('mousedown', mouseDownHandler);

    }

    /**
     * Watch slides
     * Add inview class
     * Show hide next/prev button
     */
    watchSlides() {
      // Clean up existing observer if it exists
      if (this.slidesObserver) {
        this.slidesObserver.disconnect();
        this.slidesObserver = null;
      }

      // Create options for observer
      let options = {
        root: this.selectors.wrapper,
        rootMargin: '0px',
        threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
      }

      // Slides observer
      this.slidesObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((slide) => {
          // If in view
          if (slide.isIntersecting) {
            // Add inview class to slide
            slide.target.classList.add('slider__slide--inview');

          // If out of view
          } else {
            // Remove inview class from slide
            slide.target.classList.remove('slider__slide--inview');

            // Stop youtube video
            slide.target.querySelector('media-youtube.playing')?.stopYoutube();
          }

          toggleButtons();


        });
      }, options);

      // Observe all slides
      [...this.selectors.slides].forEach(function(slide) {
        this.slidesObserver.observe(slide);
      }.bind(this));

      //  Hide/show next prev button
      const toggleButtons = () => {
        if (!this.selectors.prevButton || !this.selectors.nextButton) {
          return false;
        }

        const pos = this.selectors.wrapper.scrollLeft;
        const scrollerWidth = this.selectors.wrapper.scrollWidth - this.selectors.wrapper.clientWidth;

        // animate prev button in/out
        if (pos <= 10) {
          this.selectors.prevButton.classList.add('slider__prev-button--disabled');
        } else {
          this.selectors.prevButton.classList.remove('slider__prev-button--disabled');
        }

        // animate next button in/out
        if (pos >= (scrollerWidth - 10)) {
          this.selectors.nextButton.classList.add('slider__next-button--disabled');
        } else {
          this.selectors.nextButton.classList.remove('slider__next-button--disabled');
        }
      }
      toggleButtons();
      setTimeout(() => {
        toggleButtons(); // Wait for algolia
      }, 100);

      const toggleGradient = () => {
        if (!this.options || !this.options.gradient) {
          return false;
        }

        const pos = this.selectors.wrapper.scrollLeft;
        const scrollerWidth = this.selectors.wrapper.scrollWidth - this.selectors.wrapper.clientWidth;

        // animate prev button in/out
        if (pos <= 1) {
          this.classList.add('hide-start-gradient');
        } else {
          this.classList.remove('hide-start-gradient');
        }

        // animate next button in/out
        if (pos >= (scrollerWidth - 1)) {
          this.classList.add('hide-end-gradient');
        } else {
          this.classList.remove('hide-end-gradient');
        }
      }
      toggleGradient();
      setTimeout(() => {
        toggleGradient(); // Wait for algolia
      }, 100);

      // Scroller
      this.selectors.wrapper.addEventListener('scroll', () => {
        toggleButtons();
        toggleGradient();
      });

    }
    /**
     * Go to next / prev slide
     * @param update : {string} forward or backward
     */
    goToNextPrevSlide(update = 'forward') {
      if (!this.selectors.wrapper || !this.selectors.slides || this.selectors.slides.length === 0) {
        return;
      }

      const wrapper = this.selectors.wrapper;
      const currentScrollLeft = wrapper.scrollLeft;
      const wrapperWidth = wrapper.clientWidth;
      const maxScrollLeft = wrapper.scrollWidth - wrapperWidth;

      // Calculate offset
      const offset = window.innerWidth < 768 ? (this.options?.mobileOffset || 0) : (this.options?.offset || 0);

      let newScrollLeft;

      if (update === 'forward') {
        // Calculate how much to scroll forward
        // Try to scroll by about 75% of the visible width, or to the next slide
        const scrollAmount = Math.min(wrapperWidth * 0.75, wrapperWidth - offset);
        newScrollLeft = Math.min(currentScrollLeft + scrollAmount, maxScrollLeft);

        // If we're already at the end, don't scroll
        if (currentScrollLeft >= maxScrollLeft - 10) {
          return;
        }
      } else {
        // Calculate how much to scroll backward
        const scrollAmount = Math.min(wrapperWidth * 0.75, wrapperWidth - offset);
        newScrollLeft = Math.max(currentScrollLeft - scrollAmount, 0);

        // If we're already at the beginning, don't scroll
        if (currentScrollLeft <= 10) {
          return;
        }
      }

      // Perform the scroll
      wrapper.scrollTo({
        top: 0,
        left: newScrollLeft,
        behavior: 'smooth'
      });
    }

    /*
    * go to slide
    * @param slide {node} / {int}: slide node / index
    */
    goToSlide(slide, animate = true) {
      if (typeof slide != 'number' && typeof slide != 'object') {
        return false;
      }
      if (!this.selectors || !this.selectors.slides || this.selectors.slides.length <= index) {
        return false;
      }

      // Get index, transform node to slide index or string to int
      const index = typeof slide == 'number' ? parseInt(slide) : getNodeIndex(slide);

      // Get slide pos
      let newPos = [...this.selectors.slides][index]?.offsetLeft;
      if (newPos == undefined) {
        return false;
      }

      // go to slide
      this.selectors.wrapper.scrollTo({
        top: 0,
        left: newPos,
        behavior: animate ? 'smooth' : 'auto'
      });
    }

    /**
     * Check if clicks should be allowed (not during or immediately after drag)
     */
    shouldAllowClicks() {
      if (!this.dragState) return true;

      // Don't allow clicks if currently dragging
      if (this.dragState.isDragging) {
        return false;
      }

      // Only block clicks if there was actual dragging and it just ended
      if (this.dragState.wasDragging && this.dragState.dragEndTime) {
        const timeSinceDragEnd = Date.now() - this.dragState.dragEndTime;
        if (timeSinceDragEnd < 150) {
          return false;
        }
      }

      return true;
    }

    /**
     * Reinitialize event listeners for navigation buttons
     */
    reinitializeEventListeners() {
      // Remove existing event listeners if they exist
      if (this.prevButtonHandler && this.selectors?.prevButton) {
        this.selectors.prevButton.removeEventListener('click', this.prevButtonHandler);
      }
      if (this.nextButtonHandler && this.selectors?.nextButton) {
        this.selectors.nextButton.removeEventListener('click', this.nextButtonHandler);
      }

      // Create new event handlers
      this.prevButtonHandler = (event) => {
        if (!this.shouldAllowClicks()) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        this.goToNextPrevSlide('backward');
      };

      this.nextButtonHandler = (event) => {
        if (!this.shouldAllowClicks()) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        this.goToNextPrevSlide('forward');
      };

      // Add event listeners to buttons
      if (this.selectors.prevButton) {
        this.selectors.prevButton.addEventListener('click', this.prevButtonHandler);
      }

      if (this.selectors.nextButton) {
        this.selectors.nextButton.addEventListener('click', this.nextButtonHandler);
      }
    }

    /**
     * Cleanup method to disconnect observer and remove event listeners
     */
    disconnectedCallback() {
      if (this.slidesObserver) {
        this.slidesObserver.disconnect();
        this.slidesObserver = null;
      }

      // Remove event listeners
      if (this.prevButtonHandler && this.selectors?.prevButton) {
        this.selectors.prevButton.removeEventListener('click', this.prevButtonHandler);
      }
      if (this.nextButtonHandler && this.selectors?.nextButton) {
        this.selectors.nextButton.removeEventListener('click', this.nextButtonHandler);
      }

      // Remove global click handler
      if (this.globalClickHandler) {
        document.removeEventListener('click', this.globalClickHandler, true);
      }
    }

  }

  window.SliderComponent  = SliderComponent;

  customElements.define('slider-component', SliderComponent);

}
